export { EmailCaptureForm as default } from './EmailCaptureForm';
export { richTextDisclaimer } from '../EmailCaptureForm/data';